import React, { useEffect } from "react"
import { CONSTANT } from "../../utils/Constant"
import Swal from "sweetalert2"
import { properties } from "../../utils/Properties_es"

const MessageManager = ({ type, msg, detail, callback }) => {
  useEffect(() => {
    showMessage()
    // eslint-disable-next-line
  }, [])

  const showMessage = () => {
    Swal.fire({
      title: msg,
      text: detail,
      icon:
        type === CONSTANT.DANGER_MSG
          ? "error"
          : type === CONSTANT.WARNING_MSG
          ? "warning"
          : "success",
      confirmButtonText: properties.com_parval_label_wizard_button_ok_title,
    }).then(() => callback())
  }

  return <></>
}

export default MessageManager
